__turbopack_context__.v({
  "option": "OptionalSubsection-module-scss-module__sfxeBq__option",
  "placeholder": "OptionalSubsection-module-scss-module__sfxeBq__placeholder",
});
